import NoticeManageTableForm from './table_form.vue';

export default NoticeManageTableForm;
